import React from 'react'

function banner() {
  return (
    <div>
        <div className='bg-primary sect-spacer'>
            <div className="uk-container">
                <div className="">
                    <div>
                        <div className="">
                            <h1 className="text-primary uk-text-center">
                                Career
                            </h1>
                            <p className='uk-text-left text-secondary uk-text-center'>
                                Join our dynamic team! We offer competitive salaries, excellent benefits, and growth opportunities. <br/>Apply now to become a part of our fast-paced, innovative courier company!
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default banner